import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpLayerService } from './http-layer.service';
import { Config } from '../config/config';

@Injectable({
  providedIn: 'root',
})
export class AppService {

  constructor(private _http: HttpClient, private _httplayer: HttpLayerService) { }

  // ***************************** PNP SERVICES: START *********************************

  pnp_login(data): Observable<any> {
    // return this._httplayer.loginEncrypted(Config.API.PNP_login, data);
    return this._httplayer.post(Config.API.PNP_login, data);
  }
  // Get Token
  getTokenInfo(): Observable<any> {
    return this._httplayer.get(Config.API.GET_TOKEN);
  }
  pnp_get_image(imageName) {
    // tslint:disable-next-line:prefer-template
    return Config.API.PNP_get_image + imageName + '.jpg';
  }
  get_profile_image(input_data) {
    // tslint:disable-next-line:prefer-template
    return this._httplayer.post(Config.API.PNP_get_profile_image, input_data);
  }
  pnp_get_notifications(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_fetch_notications, data, undefined, true);
  }
  pnp_get_map_data(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_fetch_map_data, data);
  }
  pnp_list_of_hierarchy(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_list_of_hierarchy, data);
  }
  pnp_performance_prediction(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_performance_prediction, data);
  }
  pnp_bubble_chart(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_bubble_chart, data);
  }
  pnp_alert_center_list(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_alert_center_list, data);
  }
  pnp_get_threshold_info(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_get_threshold_info, data);
  }
  pnp_update_threshold_info(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_update_threshold_info, data);
  }
  pnp_getUserManagementData(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_getUserManagementData, data);
  }
  pnp_listPlantMeta(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_listPlantMeta, data);
  }
  pnp_getMSAccessConfData(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_getMSAccessConfData, data);
  }
  pnp_saveMSAccessConfData(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_saveMSAccessConfData, data);
  }
  pnp_deleteMSAccessConfData(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_deleteMSAccessConfData, data);
  }
  pnp_runMSAccessConfData(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_runMSAccessConfData, data);
  }
  pnp_getEmailConfigurationData(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_list_email_info, data);
  }
  pnp_deleteEmailConfigurationData(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_delete_email_info, data);
  }
  pnp_saveEmailConfigurationData(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_save_email_info, data);
  }
  PNP_configureEmailSubject(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_configure_email_subject, data);
  }
  pnp_appConfiguration(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_appConfiguration, data);
  }
  pnp_enableEmailConfigurationData(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_enable_email_info, data);
  }
  pnp_fetch_notifications(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_fetch_notifications, data);
  }
  pnp_log_info(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_log_info, data);
  }
  pnp_manage_container(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_manage_container, data);
  }
  pnp_debug_device(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_debug_device, data);
  }
  pnp_fqdn_device(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_fqdn_device, data);
  }
  pnp_fetch_container_logs() {
    return Config.API.PNP_fetch_container_logs;
  }
  pnp_pipeline_approve(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_pipeline_approve, data);
  }
  pnp_fetch_agent_logs() {
    return Config.API.PNP_fetch_agent_logs;
  }
  PNP_fetchEmailSubject(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_fetchEmailSubject, data);
  }
  pnp_update_notifications(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_update_notifications, data);
  }
  pnp_uploadPlantsConfiguration(formdata): Observable<any> {
    return this._httplayer.postFormData(Config.API.PNP_uploadPlantsConfiguration, formdata);
  }
  pnp_getPlantsListingTable(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_getPlantsListingTable, data);
  }
  pnp_reviewPlantsListingTable(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_reviewPlantsListingTable, data);
  }
  PNP_get_configuration_menus(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_get_configuration_menus, data);
  }
  pnp_getCountryCodes(): Observable<any> {
    return this._httplayer.get(Config.API.PNP_getCountryCodes);
  }
  pnp_setCookie(): Observable<any> {
    return this._httplayer.get(Config.API.PNP_get_name);
  }
  pnp_logout(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_logout, data);
  }
  PNP_reset_password(data): Observable<any> {
    return this._httplayer.post(Config.API.PNP_reset_password, data);
  }

  saveLogoImage(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.PNP_SAVE_LOGO_IMAGE, payload);
  }

  getLogoImage(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.PNP_GET_LOGO_IMAGE, payload);
  }
  pnp_saveEmailConfig(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.PNP_E_mailConfiguration, payload);
  }
  pnp_saveSMSConfig(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.PNP_SMSConfiguration, payload);
  }
  pnp_saveNotificationConfig(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.PNP_NOTIFICATIONConfiguration, payload);
  }
  pnp_fetchEmailConfig(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.PNP_E_mailConfiguration, payload);
  }
  pnp_fetchSMSConfig(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.PNP_SMSConfiguration, payload);
  }
  pnp_fetchNotificationHubConfig(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.PNP_NOTIFICATIONConfiguration, payload);
  }
  pnp_sendNotifications(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.PNP_SEND_NOTIFICATIONS, payload);
  }
  pnp_uploadLicenseFile(payload: any): Observable<any> {
    return this._httplayer.postFormData(Config.API.PNP_UPLOAD_LICENSE, payload);
  }
  pnp_getLicenseDetails(payload: any): Observable<any> {
    return this._httplayer.postFormData(Config.API.PNP_FETCH_LICENSE_DETAILS, payload);
  }

  pnp_fetchLicenseDetails(payload: any): Observable<any> {
    return this._httplayer.postFormData(Config.API.PNP_FETCH_LICENSE_INFO, payload);
  }

  pnp_check_session_status(): Observable<any> {
    return this._httplayer.get(Config.API.PNP_CHECK_SESSION_STATUS);
  }

  // ***************************** PNP SERVICES: END *********************************








  // login functions
  getSessionkeyService(): Observable<any> {
    return this._httplayer.get(Config.API.SESSION_KEY);
  }
  getCaptchaVerificationImage(): Observable<any> {
    return this._httplayer.get(Config.API.GET_CAPTCHA);
  }
  getCaptchaValidation(data): Observable<any> {
    return this._httplayer.post(Config.API.VALIDATE_CAPTCHA, data);
  }

  // Get License Details
  getLicenseInfo(): Observable<any> {
    return this._httplayer.get(Config.API.LICENSE_INFO);
  }

  getLoginService(data: any) {
    return this._httplayer.post(Config.API.LOGIN, data);
  }
  saloginService(data) {
    return this._httplayer.post(Config.API.SA_LOGIN, data);
  }


  forgotPassword(data) {
    return this._httplayer.post(Config.API.FORGOT_PASSWORD, data);
  }

  changePassword(data) {
    return this._httplayer.post(Config.API.UPDATEPASSWORD, data);
  }

  resetPassword(data) {
    return this._httplayer.post(Config.API.RESET_PASSWORD, data);
  }

  updateLicense(data) {
    return this._httplayer.post(Config.API.UPDATE_LICENSE, data);
  }
  getPassSA(data) {
    return this._httplayer.post(Config.API.GET_PASS_SA, data);
  }

  // Configurations

  // leftsidebar
  getLeftSideconfigData(): Observable<any> {
    return this._httplayer.post(Config.API.CONFIGURATIONS_SIDEBAR, {});
  }

  // Alarm Configurations
  getAlarmList(data): Observable<any> {
    return this._httplayer.post(Config.API.ALARM_LIST_GET, data);
  }
  getAlarmConf(id: string): Observable<any> {
    return this._httplayer.post(Config.API.ALARM_CONFIGURATION_GET, { id });
  }

  getTagsForRuleset(data: Array<any>): Observable<any> {
    return this._httplayer.post(Config.API.ALARM_CONFIGURATION_GET_TAGS, { data });
  }
  getTagsForSelectedDevice(data: Array<any>): Observable<any> {
    return this._httplayer.post(Config.API.ALARM_CONFIGURATION_GET_TAGS_FOR_DEVICE, { data });
  }

  enableOrDisableAlarm(data: any): Observable<any> {
    return this._httplayer.post(Config.API.ALARM_ENABLE_OR_DISABLE, data);
  }

  getWidgetDetailsService(widgetURL: string) {
    return this._httplayer.get(widgetURL);
  }
  getDataService(dataURL: string) {
    return this._httplayer.get(dataURL);
  }
  getDashboardGridDetails(dataURL: string) {
    return this._httplayer.get(dataURL);
  }
  /**
   * LookUp table Suggessions in the Rule Engine
   */
  getLookupSuggession() {
    return this._httplayer.post(Config.API.GET_LOOKUP_TABLES_SUGGESSIONS, {});
  }

  getFilters(): Observable<any> {
    return this._httplayer.post(Config.API.FETCH_FILTER_DATA, {});
  }

  getDashboardLeftSideconfigData(data): Observable<any> {
    return this._httplayer.post(Config.API.LIST_DASHBOARD, data);
  }
  getWidgetOrder(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_WIDGET_ORDER, data);
  }
  saveWidgetOrder(data): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_WIDGET_ORDER, data);
  }

  saveHomeDashboard(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_HOME_DASHBOARD, payload);
  }

  saveDashboard(data): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_DASHBOARD, data);
  }
  deleteDashboard(data): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_DASHBOARD, data);
  }

  getUserManagementDataService(dataURL: string) {
    return this._http.get(dataURL);
  }

  getUserGroupsService(dataURL: string) {
    return this._http.get(dataURL);
  }

  updateDashboardGridDetails(dataURL: string, innerHeight: any) {
    return this._http.patch(dataURL, { height: innerHeight });
  }

  getMasterUnits(data): Observable<any> {
    return this._httplayer.post(Config.API.MASTER_UNIT_GET_ALL, data);
  }

  getTags(data): Observable<any> {
    return this._httplayer.post(Config.API.TAG_GET, data);
  }
  getTagsList(): Observable<any> {
    return this._httplayer.post(Config.API.GET_TAGS_LIST, {});
  }

  saveTag(data: any): Observable<any> {
    return this._httplayer.post(Config.API.TAG_SAVE, { data: [data] });
  }

  deleteTag(id: string): Observable<any> {
    return this._httplayer.post(Config.API.TAG_DELETE, { id });
  }

  // -----------------------------------------------License Management-----------------------------
  getlicensetable() {
    return this._httplayer.post(Config.API.LICENSE_TABLE, {});
  }

  submit_license_key(dataToPost) {
    return this._httplayer.post(Config.API.SUBMIT_LICENSE_KEY, dataToPost);
  }

  // ===================================================SitePage ======================================
  getSitesList(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.INDUSTRY_GET_LIST, dataToPost);
  }
  getSiteData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.INDUSTRY_LOAD_TEMPLETE, dataToPost);
  }
  saveSiteData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.INDUSTRY_SAVE, dataToPost);
  }
  updateSiteData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.INDUSTRY_UPDATE, dataToPost);
  }
  // ================================================== MAnual Entry Page =============================
  getManualentrymenus(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.MANUAL_ENTRY_MENU, dataToPost);
  }
  getManualEntryMetaData(dataToPost, endpointExtension): Observable<any> {
    return this._httplayer.post(Config.API.MANUAL_ENTRY_GETMETADATA + '/' + endpointExtension, dataToPost);
  }
  saveConfigManualEntry(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.MANUAL_ENTRY_SAVE_CONFIG, dataToPost);
  }
  getManualEntryRecord(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.MANUAL_ENTRY_GET_ENTRY, dataToPost);
  }
  getManualEntryTableData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.MANUAL_ENTRY_FETCH_TABLE, dataToPost);
  }
  getBatchList(data): Observable<any> {
    return this._httplayer.post(Config.API.MANUAL_ENTRY_BATCH_LIST, data);
  }
  saveManualEntry(data): Observable<any> {
    return this._httplayer.post(Config.API.MANUAL_ENTRY_SAVE, data);
  }
  saveMetaDataServ(data): Observable<any> {
    return this._httplayer.post(Config.API.MANUAL_ENTRY_SAVE_METADATA, data);
  }

  // ===================================================UserManagementPage ======================================
  // ------------------------------------User List------------------------------------------
  getUserList(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.USERLIST_GET_USER_LIST, dataToPost);
  }
  getUserMgmtDropdown(value): Observable<any> {
    return this._httplayer.post(Config.API.USERLIST_GET_DROPDOWN, {});
  }
  saveUserData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.USERLIST_SAVE_USER, dataToPost);
  }
  deleteUserData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.USERLIST_DELETE_USER, dataToPost);
  }

  upload(fileToUpload: any) {

    const input = new FormData();
    input.append('file', fileToUpload);

    return this._http.post('/api/uploadFile', input);
  }

  // ------------------------------------Work Group------------------------------------------

  getWorkGroupList(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.GET_WORKGROUP_LIST, dataToPost);
  }
  saveWorkGroup(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_WORKGROUP, dataToPost);
  }
  deleteWorkGroup(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_WORKGROUP, dataToPost);
  }

  // =============================================Business Groups======================================
  // ---------------------------------------------Device Groups----------------------------------------
  getdeviceGroupsList(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_GROUP_LIST, dataToPost);
  }
  loadDeviceGroup(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_GROUP_FETCH, dataToPost);
  }
  updateDeviceGroup(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_GROUP_UPDATE, dataToPost);
  }
  // ---------------------------------------------Tag Groups----------------------------------------
  getTagGroupsList(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.TAG_GROUP_LIST, dataToPost);
  }
  loadTagGroup(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.TAG_GROUP_FETCH, dataToPost);
  }
  updateTagGroup(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.TAG_GROUP_UPDATE, dataToPost);
  }

  // ===========================================Master Config=========================================
  // -------------------------------------------Device Model------------------------------------------
  getDeviceModelsList(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_MODEL_GETLIST, dataToPost);
  }
  getDeviceModelList(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_MODEL_LOAD_TEMPLETE, dataToPost);
  }
  saveDeviceModelData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_MODEL_LOAD_SAVE, dataToPost);
  }
  deleteDeviceModel(data): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_MODEL_DELETE, data);
  }
  uploadBlockCsv(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_MODEL_UPLOAD_CSV, dataToPost);
  }
  getDeviceModelProtocols() {
    return this._httplayer.post(Config.API.DEVICE_MODEL_PROTOCOL_LIST, {});
  }

  // -------------------------------------------Batch Entry------------------------------------------

  getTagGroupsOrBatchDetails(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.GET_TAG_GROUPS_OR_BATCH_DETAILS, dataToPost);
  }
  getTagsForBatchEntry(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.GET_TAGS_IN_TAG_GROUP, dataToPost);
  }

  getBatchEntry(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.GET_BATCH_ENTRY, dataToPost);
  }

  saveBatchEntry(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_BATCH_ENTRY, dataToPost);
  }

  deleteBatchEntry(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_BATCH_ENTRY, dataToPost);
  }

  // ---------------------------------------------LookUp Service calls--------------------------------

  // Lookup Configuration

  savelookup(formdata): Observable<any> {
    return this._httplayer.post(Config.API.ADD_LOOKUP, formdata);
  }

  lookupConfigurationtabledata(data): Observable<any> {
    return this._httplayer.post(Config.API.LOOKUP_TABLEDATA, data);
  }

  deletelookup(lookupid): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_LOOKUP, { lookup_id: lookupid });
  }

  // Lookup Tables

  lookupsList(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.LOOKUPS_LIST, dataToPost);
  }

  getlookuptabledata(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.LOOKUPS_TABLE, dataToPost);
  }

  submitlookup(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.SUBMIT_LOOKUP, dataToPost);
  }

  // -------------------------------------------User Mnagement------------------------------------------

  usersetupConfigurationtabledata(data): Observable<any> {
    return this._httplayer.post(Config.API.USER_TABLEDATA, data);
  }
  editUser(data): Observable<any> {
    return this._httplayer.post(Config.API.EDIT_USER, data);
  }
  deleteuser(userid): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_USER, { user_id: userid });
  }
  addNewUser(formdata): Observable<any> {
    return this._httplayer.post(Config.API.ADD_USER, formdata);
  }

  // -------------------------------------------User role------------------------------------------

  editUserrole(data): Observable<any> {
    return this._httplayer.post(Config.API.EDIT_USERROLE, data);
  }
  deleteuserrole(userrole): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_USERROLE, { user_role: userrole });
  }
  addNewUserRole(formdata): Observable<any> {
    return this._httplayer.post(Config.API.ADD_USERROLE, formdata);
  }
  saveuserrole(formdata): Observable<any> {
    return this._httplayer.post(Config.API.ADD_LOOKUP, formdata);
  }

  // -----------------------------------------User Access Level -------------------
  deleteAccessLevelData(data): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_ACCESS_LEVEL, data);
  }
  saveAccessLevelData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_ACCESS_LEVEL, dataToPost);
  }
  getAccessLevelDataList(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.GET_ACCESSLEVEL_LIST, dataToPost);
  }

  // -------------------------------------------Unit Converter------------------------------------------

  getUnitConverterData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.GET_UNIT_CONVERTER_OR_UNITS, dataToPost);
  }

  saveUnitConverter(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_UNIT_CONVERTER, dataToPost);
  }



  // ===================================================Unit and Threshold Configuratioin ======================================
  getUnits(data): Observable<any> {
    return this._httplayer.post(Config.API.UNIT_GET, data);
  }
  saveOrUpdateUnit(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.UNIT_SAVE, dataToPost);
  }

  getUnitsList(data): Observable<any> {
    return this._httplayer.post(Config.API.UNIT_GET_LIST, data);
  }

  deleteUnit(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.UNIT_DELETE, dataToPost);
  }

  getThresholds(data): Observable<any> {
    return this._httplayer.post(Config.API.THRESHOLD_GET, data);
  }

  saveOrUpdateThreshold(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.THRESHOLD_SAVE, dataToPost);
  }

  deleteThreshold(data: any): Observable<any> {
    return this._httplayer.post(Config.API.THRESHOLD_DELETE, data);
  }
  // ++++++++++++++++++++++++++++++++++++++++++++++++Dashboard+++++++++++++++++++++++++++++++++++++

  getChartInfo(dataToPost): Observable<any> {
    return this._httplayer.postDashboard(Config.API.CHART_PREVIEW_DATA, dataToPost);
    // return this._httplayer.postDashboard(Config.API.DASHBOARD_CHART_DATA, dataToPost);
  }

  generateReport(dataToPost): Observable<any> {
    return this._httplayer.postDashboard(Config.API.REPORT_GENERATE, dataToPost);
    // return this._httplayer.postDashboard(Config.API.DASHBOARD_CHART_DATA, dataToPost);
  }

  // +++++++++++++++++++++++++++++++++++++++++++++++ Widget Config +++++++++++++++++++++++++++++++++++++

  getPreviewChartData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.CHART_PREVIEW_DATA, dataToPost);
  }
  postChartAnotationService(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.CHART_ANNOTATE, dataToPost);
  }
  getPreviewChartDataTopics(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.CHART_PREVIEW_DATA_TOPICS, dataToPost);
  }
  getChartConfigMetaData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.CHART_GET_METADATA, dataToPost);
  }
  getChartConfigTagsData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.CHART_GET_TAG_DATA, dataToPost);
  }
  getChartUnitMetaData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.CHART_GET_UNIT_METADATA, dataToPost);
  }
  saveWidgetConfigData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_WIDGET_DATA, dataToPost);
  }

  getDashboardData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.GET_DASHBOARD_DATA, dataToPost);
  }

  deleteWidget(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_WIDGET, dataToPost);
    // return this._httplayer.postDashboard(Config.API.DASHBOARD_CHART_DATA, dataToPost);
  }

  // ****************************************** Visualization preview ***************************** /
  saveVisualWidgetConfigData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.VISUAL_SAVE_WIDGET_DATA, dataToPost);
  }
  getVisualPreviewChartData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.VISUAL_PREVIEW_DATA, dataToPost);
  }

  getVisualChartInfo(dataToPost): Observable<any> {
    return this._httplayer.postDashboard(Config.API.VISUAL_PREVIEW_DATA, dataToPost);
  }

  postVisualChartAnotationService(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.VISUAL_CHART_ANNOTATE, dataToPost);
  }
  visualDeleteAnnotation(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.VISUAL_DELETE_WIDGET_ANNOTATION, payload);
  }

  generateReportVisualization(dataToPost) {
    return this._httplayer.postDashboard(Config.API.VISUAL_REPORT_GENERATE, dataToPost);
  }

  onloadNotifications(dataToPost) {
    return this._httplayer.post(Config.API.VISUAL_NOTIFICATION_LIST, dataToPost);
  }
  // ****************************************** Mater gateway and Channel Configuration************/

  // MASTER CONFIGURATION GATEWAY APIS

  // getProtocols(): Observable<any> {

  //   return this._http.post(Config.API.GATEWAY_MODEL_PROTOCOL_LIST, {});
  // }
  getGatewayProtocols(): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_MODEL_PROTOCOL_LIST, {});
  }
  // gateway model protocols
  getModelProtocolsBody(): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_MASTER_DFM, {});
  }

  createGatewayModel(jsonData): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_SAVE, jsonData);
  }

  getSavedogatewaysData(key): Observable<any> {
    return this._httplayer.post(Config.API.GATEWAY_MASTER_DFM, { key });
  }

  getgatewaysDataLists(data): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_GET_LIST, data);
  }

  deviceMigration(data): Observable<any> {

    return this._httplayer.post(Config.API.DEVICE_MIGRATION, data);
  }

  // AI
  // AI Models

  getAIDataLists(data): Observable<any> {
    return this._httplayer.post(Config.API.AI_MODEL_GET, data);
  }

  getMetaInfo(inputJson): Observable<any> {
    return this._httplayer.post(Config.API.AI_MODEL_DETAIL, inputJson);
  }

  saveAIModelData(data): Observable<any> {
    return this._httplayer.post(Config.API.AI_MODEL_CREATE, data);
  }

  getAIModelData(data): Observable<any> {
    return this._httplayer.post(Config.API.AI_MODEL_EDIT, data);
  }

  deleteAIModelData(data): Observable<any> {
    return this._httplayer.post(Config.API.AI_MODEL_DELETE, data);
  }

  getAIRulesList(data) {
    return this._httplayer.post(Config.API.AI_RULE_GET, data);
  }

  saveAIRuleData(data) {
    return this._httplayer.post(Config.API.AI_RULE_CREATE, data);
  }

  editAIRuleData(data) {
    return this._httplayer.post(Config.API.AI_RULE_EDIT, data);
  }

  deleteAIRuleData(data) {
    return this._httplayer.post(Config.API.AI_RULE_DELETE, data);
  }

  getAssetInfo(data): Observable<any> {
    return this._httplayer.post(Config.API.AI_RULE_ASSETS, data);
  }

  getFilteredTags(data): Observable<any> {
    return this._httplayer.post(Config.API.AI_RULE_TAGS, data);
  }

  getChartDataOfTag(data): Observable<any> {
    return this._httplayer.post(Config.API.AI_RULE_CHART, data);
  }

  getGatewaysDataBYID(key): Observable<any> {
    return this._httplayer.post(Config.API.GATEWAY_LOAD_MODEL_INSTANCE_TEMPLETE, { key });
    // return this._http.post(Config.API.GATEWAY_MASTER_DFM, { key: key });
  }
  getGatewaysDataByModel(key): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_LOAD_TEMPLETE1, { key });
  }
  getChannelRowProtocols(data): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_INSTANCE_PROTOCOL_LIST, data);
  }
  getChannelgatewaysModels(data): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_INSTANCE_GET_GATEWAY_MODEL_LIST, data);
  }
  getChannelRowProtocolsWithDFM(): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_LOAD_TEMPLETE1, {});
  }
  createGateway(data): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_CREATE, data);
  }
  getChannelRowGatewaysDataByModel(key): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_LOAD_TEMPLETE1, { key });
  }
  getCardSettings(data): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_SILO, data);
  }
  getDeviceModelData(data): Observable<any> {

    return this._httplayer.post(Config.API.CHANNEL_DEVICE_MODEL_LIST, data);
  }
  getDevices(data): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_SILO, data);
  }
  getDFMDeviceModelBodyByID(dataToSend): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_LOAD_MODEL_INSTANCE_TEMPLETE, dataToSend);
  }
  getDFMDeviceModelBody(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_MODEL_LOAD_INSTANCE, dataToPost);
  }
  getDFMDeviceModelBodyContentByID(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_MODEL_LOAD_INSTANCE, dataToPost);
  }
  deleteGateway(key, value): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_DELETE, { gateway_instance_id: key, action: value });
  }

  disableGateway(key, value): Observable<any> {

    return this._httplayer.post(Config.API.GATEWAY_DISABLE, { gateway_instance_id: key, action: value });
  }

  deleteDevice(key, value): Observable<any> {

    return this._httplayer.post(Config.API.DEVICE_DELETE, { device_instance_id: key, action: value });
  }
  disableDevice(key, value): Observable<any> {

    return this._httplayer.post(Config.API.DEVICE_DISABLE, { device_instance_id: key, action: value });
  }

  getDeviceModelsConfiguraionList(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_INSTANCE_LIST, dataToPost);
  }

  getDeviceModelConfigurationList(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_MODEL_LOAD_INSTANCE, dataToPost);
  }
  saveDeviceModelConfigurationData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_MODEL_LOAD_CREATE, dataToPost);
  }

  getDeviceTypes(): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_TYPES_GET, {});
  }

  saveDeviceType(data: any): Observable<any> {
    // return this._httplayer.post(Config.API.DEVICE_TYPES_CREATE, { data : [data] });
    return this._httplayer.post(Config.API.DEVICE_TYPES_CREATE, data);
  }

  deleteDeviceType(id: string): Observable<any> {
    return this._httplayer.post(Config.API.DEVICE_TYPES_DELETE, { id });
  }

  getUtilizedCount(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_UTILIZED_COUNT, data);
  }

  getGatewayTypes(): Observable<any> {
    return this._httplayer.post(Config.API.GATEWAY_TYPES_GET, {});
  }

  saveGatewayType(data: any): Observable<any> {
    return this._httplayer.post(Config.API.GATEWAY_TYPES_CREATE, data);
  }

  deleteGatewayType(id: string): Observable<any> {
    return this._httplayer.post(Config.API.GATEWAY_TYPES_DELETE, { id });
  }

  getAlarmPriorityTypes(): Observable<any> {
    return this._httplayer.post(Config.API.ALARM_PRIORITY_TYPE_GET, {});
  }

  saveAlarmPriorityType(data: any): Observable<any> {
    return this._httplayer.post(Config.API.ALARM_PRIORITY_TYPE_CREATE, data);
  }

  deleteAlarmPriorityType(id: string): Observable<any> {
    return this._httplayer.post(Config.API.ALARM_PRIORITY_TYPE_DELETE, { id });
  }

  acknowledgeAlarm(data) {
    return this._httplayer.post(Config.API.ACKNOWLEDGE_ALARMS_EVENTS, data);
  }

  saveAlarmConfig(data: any) {
    return this._httplayer.post(Config.API.ALARM_CONFIGURATION_CREATE, data);
  }

  deleteAlarmConfig(id: string) {
    return this._httplayer.post(Config.API.ALARM_CONFIGURATION_DELETE, { id });
  }

  getMultiplicationFactors(data): Observable<any> {
    return this._httplayer.post(Config.API.MULTIPLICATION_FACTOR_GET, data);
  }

  saveMultiplicationFactor(data: any): Observable<any> {
    return this._httplayer.post(Config.API.MULTIPLICATION_FACTOR_CREATE, data);
  }

  deleteMultiplicationFactor(id: string): Observable<any> {
    return this._httplayer.post(Config.API.MULTIPLICATION_FACTOR_DELETE, { multiplication_factor_id: id });
  }

  // gateway status

  getGatewayStatus() {
    return this._httplayer.postDashboard(Config.API.GATEWAY_STATUS, {});
  }

  // Time Slot
  getShiftDetails(data): Observable<any> {
    return this._httplayer.post(Config.API.LATESTTIMESLOT_GET, data);
  }
  getFullTree(): Observable<any> {
    return this._httplayer.post(Config.API.FULLTREE_GET, {});
  }
  getTimeSlot(name: any): Observable<any> {
    return this._httplayer.post(Config.API.TIMESLOT_GET, { timeslot_id: name });
  }
  saveTimeSlot(data: any): Observable<any> {
    return this._httplayer.post(Config.API.TIMESLOT_SAVE, data);
  }
  // Alarm Type
  getAlarmType(): Observable<any> {
    return this._httplayer.post(Config.API.ALARMTYPE_GET, {});
  }
  saveOrUpdateAlarmType(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.ALARMTYPE_SAVE, dataToPost);
  }
  deleteAlarmType(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.ALARMTYPE_DELETE, dataToPost);
  }

  // Function Code
  getModbusFunctionCode(): Observable<any> {
    return this._httplayer.post(Config.API.FUNCTION_CODE_GET, {});
  }
  saveOrUpdateFunctionCode(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.FUNCTION_CODE_SAVE, dataToPost);
  }
  deleteFunctionCode(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.FUNCTION_CODE_DELETE, dataToPost);
  }

  // Aggregation Type
  getAggregationType(): Observable<any> {
    return this._httplayer.post(Config.API.AGGREGATION_TYPE_GET, {});
  }
  saveOrUpdateAggregationType(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.AGGREGATION_TYPE_SAVE, dataToPost);
  }
  //   saveOrUpdateAggregationType(dataToPost: any, apiName: any): Observable<any> {
  //     return this._httplayer.post(Config.API[apiName], dataToPost);
  // }
  deleteAggregationType(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.AGGREGATION_TYPE_DELETE, dataToPost);
  }

  // Data Type
  getAllDataType(): Observable<any> {
    return this._httplayer.post(Config.API.DATA_TYPE_GET, {});
  }
  saveOrUpdateDataType(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.DATA_TYPE_SAVE, dataToPost);
  }
  deleteDataType(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.DATA_TYPE_DELETE, dataToPost);
  }
  // Frequenct List
  getFrequencyList(): Observable<any> {
    return this._httplayer.post(Config.API.FREQUENCY_LIST_GET, {});
  }
  saveOrUpdateFrequencyList(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.FREQUENCY_LIST_SAVE, dataToPost);
  }
  deleteFrequencyList(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.FREQUENCY_LIST_DELETE, dataToPost);
  }
  // Protocol List
  getProtocolList(): Observable<any> {
    return this._httplayer.post(Config.API.PROTOCOL_LIST_GET, {});
  }
  saveOrUpdateProtocolList(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.PROTOCOL_LIST_SAVE, dataToPost);
  }
  deleteProtocolList(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.PROTOCOL_LIST_DELETE, dataToPost);
  }
  getProtocolData(payload): Observable<any> {
    return this._httplayer.post(Config.API.GET_PROTOCOL_DATA, payload);
  }



  // Protocol Category
  getProtocolCategory(): Observable<any> {
    return this._httplayer.post(Config.API.PROTOCOL_CATEGORY_GET, {});
  }
  saveOrUpdateProtocolCategory(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.PROTOCOL_CATEGORY_SAVE, dataToPost);
  }
  deleteProtocolCategory(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.PROTOCOL_CATEGORY_DELETE, dataToPost);
  }
  // Alarm Notification Type
  getAlarmNotifyType(): Observable<any> {
    return this._httplayer.post(Config.API.ALARM_NOTIFY_TYPE_GET, {});
  }
  saveOrUpdateAlarmNotificationType(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.ALARM_NOTIFY_TYPE_SAVE, dataToPost);
  }
  deleteAlarmNotificationType(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.ALARM_NOTIFY_TYPE_DELETE, dataToPost);
  }

  // email gateway Configuration
  getemailgatewaytable(data): Observable<any> {
    return this._httplayer.post(Config.API.EMAIL_GATEWAY_TABLE, data);
  }

  saveEmailgateway(dataToSend): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_EMAIL_GATEWAY, dataToSend);
  }

  deleteEmailgateway(dataToSend): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_EMAIL_GATEWAY, dataToSend);
  }
  sendTestmail(dataToSend): Observable<any> {
    return this._httplayer.post(Config.API.SEND_TEST_MAIL, dataToSend);
  }
  emailDefaultGateway(dataToSend): Observable<any> {
    return this._httplayer.post(Config.API.EMAIL_DEFAULT_GATEWAY, dataToSend);
  }

  // sms gateway Configuration
  getsmsgatewaytable(data): Observable<any> {
    return this._httplayer.post(Config.API.SMS_GATEWAY_TABLE, data);
  }
  deletesmsgateway(datatopost): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_SMS_GATEWAY, datatopost);
  }
  saveSmsgateway(dataToSend): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_SMS_GATEWAY, dataToSend);
  }
  sendTestsms(dataToSend): Observable<any> {
    return this._httplayer.post(Config.API.SEND_TEST_SMS, dataToSend);
  }

  smsDefaultGateway(dataToSend): Observable<any> {
    return this._httplayer.post(Config.API.SMS_DEFAULT_GATEWAY, dataToSend);
  }

  // Time Slot Group
  getTimeSlotGrp(data): Observable<any> {
    return this._httplayer.post(Config.API.TIME_SLOT_GROUP_GET, data);
  }
  saveOrUpdateTimeSlotGroup(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.TIME_SLOT_GROUP_SAVE, dataToPost);
  }
  deleteTimeSlotGroup(dataToPost: any): Observable<any> {
    return this._httplayer.post(Config.API.TIME_SLOT_GROUP_DELETE, dataToPost);
  }

  /* ==================================Alarms & Events============================== */

  getAlarmJson(data_to_load): Observable<any> {
    return this._httplayer.post(Config.API.GET_ALARMS_EVENTS, data_to_load);
  }
  getNotesList(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_NOTES_OF_TRIGGERED_ALARM, data);
  }
  saveNotes(data): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_NOTES_OF_TRIGGERED_ALARM, data);
  }

  /* ==================================Rule Engine Sevices Starts Here============================== */
  /* ----------------------------------------------------------------------------------------------- */
  /**
   * Method for getting the table and read row data
   * @param data is an object (empty or id) for fetch row
   */
  getTableDataAndRowData(data) {
    return this._httplayer.post(Config.API.GET_RULE_TABLE_AND_ROW_DATA, data);
  }

  /**
   * Method for creating/editing the rule form
   * @param data is an object (empty or id)
   */
  saveAndEditRuleForm(data) {
    return this._httplayer.post(Config.API.SAVE_RULE_FORM_DATA, data);
  }
  /**
   * Method for deleting the rule by id
   * @param data is rule id
   */
  deleteRuleById(id) {
    const id_Obj = { rule_engine_id: id };
    return this._httplayer.post(Config.API.DELETE_RULE_BY_ID, id_Obj);
  }
  /**
 * Method for deleting the rule by id
 */
  getAllRuleMetaData() {
    return this._httplayer.post(Config.API.RULE_ENGINE_METADATA, {});
  }
  /**
   * Method for getting all tag suggetion for rule builder
   */
  getAllMonacoSuggetion(payload) {

    return this._httplayer.post(Config.API.GET_MONACO_SUGGETION, payload);
  }

  /**
   * Method for checking if tag is overide or not
   */
  checkIfTagIsOveride(data) {
    return this._httplayer.post(Config.API.CHECK_IF_TAG_OVERRIDE, data);
  }

  // ========================================== Scada Services ============================================
  getSldsidebar() {
    return this._httplayer.post(Config.API.SLD_LEFTSIDEBAR, {});
  }
  getOperatorData() {
    return this._httplayer.post(Config.API.SLD_OPERATOR_DATA, {});
  }
  getEngineerData() {
    return this._httplayer.post(Config.API.SLD_ENGINEER_DATA, {});
  }
  create_sld(dataToPost) {
    return this._httplayer.post(Config.API.CREATE_SLD, dataToPost);
  }
  create_new_sld(dataPost) {
    return this._httplayer.post(Config.API.CREATE_SLD_POINT, dataPost);
  }
  update_sld(dataPost) {
    return this._httplayer.post(Config.API.UPDATE_SLD, dataPost);
  }
  delete_sld(dataPost) {
    return this._httplayer.post(Config.API.DELETE_SLD, dataPost);
  }
  get_sld_data(dataPost) {
    return this._httplayer.post(Config.API.GET_SLD_DATA, dataPost);
  }
  moveSLDToAnotherSite(dataPost) {
    return this._httplayer.post(Config.API.MOVE_SLD_TO_ANOTHER_SITE, dataPost);
  }

  get_sld_tag_extention(dataPost) {
    return this._httplayer.post(Config.API.GET_SLD_TAG_EXTENTION, dataPost);
  }

  update_tree(dataToPost) {
    return this._httplayer.post(Config.API.UPDATE_SLD_TREE, dataToPost);
  }
  sld_audit_log_Update(dataToPost) {
    return this._httplayer.post(Config.API.AUDIT_LOG_TRIGGER, dataToPost);
  }

  /* ---------------------------Assets management SLD services--------------------- */
  comonnonGetService(url) {
    return this._http.get(url)
      .catch((err: any) => {
        if (err.status == 401 || err.status == 403) {
          // this._router.navigate(['p/login']);
          return Observable.empty();
        } else {
          return Observable.throw(err.json().error || 'Server error');
        }
      });
  }
  comonnonPostService(url, input) {
    return this._httplayer.post(url, input) //this.options - 3rd argument
      .catch((err: any) => {
        console.error(err);
        if (err.status === 401 || err.status === 403) {
          return Observable.empty();
        } else {
          return Observable.throw(err.json().error || 'Server error');
        }
      });
  }
  ReportsDownload(bodyData: Object) {
    return this.comonnonPostService(Config.API.DOWNLOADSREPORT_ENDPOINT, bodyData);
  }
  downloadService(filename: string) {
    const query = Config.API.REPORT_END_POINT + 'download?filename=' + filename;
    window.open(query);
  }

  SaveScadaData(bodyData: Object) {
    return this.comonnonPostService(Config.API.SAVE, bodyData);
  }
  FetchScadaData(bodyData: Object) {
    return this.comonnonPostService(Config.API.FETCH, bodyData);
  }

  delete_sld_sld(dataToPost) {
    return this.comonnonPostService(Config.API.DELETE_SLD, dataToPost);
  }

  create_and_list_assets_folder(dataToPost) {
    return this.comonnonPostService(Config.API.CREATE_AND_LIST_ASSETS_FOLDER, dataToPost);
  }
  upload_and_get_svg_path(dataToPost) {
    // return this.comonnonPostService(Config.API.UPLOAD_AND_GET_SVG_PATH, dataToPost);
    return this.comonnonPostService(Config.API.UPLOAD_AND_GET_ASSET_DETAILS, dataToPost);
  }
  upload_final_svg_config_data(dataToPost) {
    return this.comonnonPostService(Config.API.UPLOAD_FINAL_SVG_WITH_CONFIG_DATA, dataToPost);
  }

  get_sld_list(dataToPost) {
    return this._httplayer.post(Config.API.FETCH, dataToPost);
  }
  deleteAssetsFormLibrary(dataToPost) {
    return this._httplayer.post(Config.API.DELETE_LIBRARY_ASSETS, dataToPost);
  }
  moveAssetsToAnotherFolder(dataToPost) {
    return this._httplayer.post(Config.API.MOVE_ASSETS_TO_ANOTHER_FOLDER, dataToPost);
  }
  getTabs(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_TABS, data);
  }

  // ============================================== Scada services end ===========================================
  getwritterTopics(writterTags): Observable<any> {
    return this._httplayer.post(Config.API.WRITTER_TAGS, writterTags);
  }
  getUserWorkGroupList(passinData): Observable<any> {
    return this._httplayer.post(Config.API.USER_WORKGROUP_LIST, passinData);
  }
  getHMICurrentUserDetails(passInData): Observable<any> {
    return this._httplayer.post(Config.API.CURRENT_SUER_DETAILS, passInData);
  }
  getHighAvailabilityTags(passInData): Observable<any> {
    return this._httplayer.post(Config.API.HIGH_AVAILIBITY, passInData);
  }
  updateSldName(passInData): Observable<any> {
    return this._httplayer.post(Config.API.UPDATE_SLD_NAME, passInData);
  }
  getHmiUserListForShare(passInData): Observable<any> {
    return this._httplayer.post(Config.API.GET_USER_LIST_FOR_HMI_SHARING, passInData);
  }

  /* -------------------------Assets management SLD services(Ends)--------------------- */

  // ++++++++++++++++++++++++++++++++++++++++++++++++Dashboard+++++++++++++++++++++++++++++++++++++

  getInactiveGatewayAndDeviceCount(dataToPost) {
    return this._httplayer.post(Config.API.INACTIVE_GATEWAY_AND_DEVICE_COUNT, dataToPost);
    // return '';
  }
  editDashboard(dataToPost) {
    return this._httplayer.post(Config.API.EDIT_DASHBOARD, dataToPost);
    // return '';
  }

  getUserListAndUserGroups(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_USER_META, data);
  }

  getScheduleInfo(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_SCHEDULE_INFO, data);
  }

  saveScheduleInfo(data): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_SCHEDULE_INFO, data);
  }

  getDashboardShareInfo(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_DASHBOARD_SHARE_INFO, data);
  }

  saveDashboardShareInfo(data): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_DASHBOARD_SHARE_INFO, data);
  }
  getAlertMessages(data): Observable<any> {
    return Config.ALERT_MESSAGES[data];
  }

  // ++++++++++++++++++++++++++++++++ Reports +++++++++++++++++
  getBasicFiltersData(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.GET_BASIC_FILTER_DATA, dataToPost);
  }
  getFilteredSites(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.GET_FILTERED_STES_FOR_SLD_CREATION, dataToPost);
  }
  getSitesDevices(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.GET_SITES_DEVICES, dataToPost);
  }
  getDevicesTags(dataToPost): Observable<any> {
    return this._httplayer.post(Config.API.GET_DEVICES_TAGS, dataToPost);
  }
  saveReportConfig(data): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_REPORT, data);
  }
  previewReport(data): Observable<any> {
    return this._httplayer.post(Config.API.PREVIEW_REPORT, data);
  }
  getReportMenus(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_REPORTS_LIST, data);
  }
  saveReportConfigData(data): Observable<any> {
    return this._httplayer.post(Config.API.REPORT_WIDGET_SAVE, data);
  }
  getReportData(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_REPORT_DATA, data);
  }
  deleteReport(data): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_REPORT, data);
  }
  saveReportShare(InputJson): Observable<any> {
    return this._httplayer.post(Config.API.SHARE_REPORT, InputJson);
  }
  getReportShareInfo(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_REPORT_SHARE_INFO, data);
  }

  deleteGatewayModel(data): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_GATEWAY_MODEL, data);
  }
  getAiRules(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_AI_RULES_DROPDOWN, data);
  }
  getAiRuleChartConfigTagsData(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_AI_RULES_CHARTCONFIG_DATA, data);
  }

  // RFID

  saveRFIDNewUser(data) {
    return this._httplayer.post(Config.API.RFID_NEW_USER, data);
  }

  deleteRFIDUser(data) {
    return this._httplayer.post(Config.API.RFID_DELETE_USER, data);
  }

  getRFIDMasterTable(): Observable<any> {
    return this._httplayer.post(Config.API.RFID_MASTER_TABLE, {});
  }

  getRFIDCurrentTable(): Observable<any> {
    return this._httplayer.post(Config.API.RFID_CURRENT_TABLE, {});
  }

  getRFIDHistoricalTable(data): Observable<any> {
    return this._httplayer.post(Config.API.RFID_HISTORICAL_TABLE, data);
  }

  getRFIDMetaData(): Observable<any> {
    return this._httplayer.post(Config.API.RFID_META_DATA, {});
  }
  //  =================== Client model services =========================

  getClientLists(): Observable<any> {
    return this._httplayer.post(Config.API.GET_CLIENT_LIST, {});
  }
  getClientData(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_CLIENT_DATA, data);
  }
  saveClient(data): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_CLIENT_ITEM, data);
  }
  deleteClient(data): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_CLIENT_ITEM, data);
  }
  disableClient(data): Observable<any> {
    return this._httplayer.post(Config.API.DISABLE_CLIENT_ITEM, data);
  }
  getStandaloneLicense(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_STANDALONE_LICENSE_DETAILS, data);
  }
  getDfmForMeta(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_DFM_FOR_META_STORE, data);
  }
  userLogout(data): Observable<any> {
    return this._httplayer.post(Config.API.USER_LOGOUT, data);
  }
  disableSite(data): Observable<any> {
    return this._httplayer.post(Config.API.INDUSTRY_DISABLE, data);
  }
  enableSite(data): Observable<any> {
    return this._httplayer.post(Config.API.INDUSTRY_ENABLE, data);
  }
  fetchZIPCodeData(data): Observable<any> {
    return this._httplayer.post(Config.API.FETCH_ZIP_CODE_DATA, data);
  }


  // // scada
  // getTabs(data): Observable<any> {
  //   return this._httplayer.post(Config.API.GET_TABS, data);
  // }

  getLicenseDetails(data): Observable<any> {
    return this._httplayer.post(Config.API.CLIENT_LICENSE_DETAILS, data);
  }
  // ++++++++++++++++++++++++++++Logs Endpoints +++++++++++
  getLogsMenus(data): Observable<any> {
    return this._httplayer.post(Config.API.LOGS_LIST, data);
  }
  saveLog(data): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_LOG, data);
  }
  deleteLog(data): Observable<any> {
    return this._httplayer.post(Config.API.LOG_DELETE, data);
  }
  getLogData(data): Observable<any> {
    return this._http.post(Config.API.LOG_WIDGET_LIST, data);
  }
  previewLog(data): Observable<any> {
    return this._httplayer.post(Config.API.LOG_PREVIEW, data);
  }
  saveLogConfigData(data): Observable<any> {
    return this._httplayer.post(Config.API.LOG_WIDGET_SAVE, data);
  }
  saveLogShare(InputJson): Observable<any> {
    return this._httplayer.post(Config.API.SHARE_LOG, InputJson);
  }
  getLogShareInfo(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_LOG_SHARE_INFO, data);
  }
  saveLogbookEntry(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_LOGBOOK_ENTRY, payload);
  }

  /** Sign up Services hits  */
  signUp(payload): Observable<any> {
    return this._httplayer.post(Config.API.SIGN_UP, payload);
  }

  // ================================================== Energy Summary ======================================
  getMonacoEditorSuggestions(data): Observable<any> {
    return this._httplayer.post(Config.API.GET_MONACO_EDITOR_SUGGESTIONS, data);
  }

  saveScheduleEnergyReportInfo(payload): Observable<any> {
    return this._httplayer.post(Config.API.SAVE_SCHEDULE_ENERGYREPORT, payload);
  }

  getEnergyReportScheduleInfo(payload): Observable<any> {
    return this._httplayer.post(Config.API.GET_ENERGYREPORT_SCHEDULEINFO, payload);
  }

  // ---------------------------------------------- Device List page  -------------------------------------
  cloudGetDeviceList(data) {
    return this._httplayer.post(Config.API.CLOUD_DEVICES_LIST, data);
  }
  cloudDeleteDevice(data) {
    return this._httplayer.post(Config.API.CLOUD_DELETE_DEVICE, data);
  }
  cloudDownloadDeviceConfig(data) {
    return this._httplayer.post(Config.API.CLOUD_DOWNLOAD_DEVICE_CONFIG, data);
  }
  cloudViewDeviceConfig(data) {
    return this._httplayer.post(Config.API.CLOUD_DEVICE_DETAILS, data);
  }
  // ---------------------------------------------- Device Add/Edit -------------------------------------
  getMetaDataForPublicPortal(data) {
    return this._httplayer.post(Config.API.METADATA_PUBLIC_PORTAL, data);
  }
  getAllKeys(data) {
    return this._httplayer.post(Config.API.CLOUD_DEVICE_LISTING_OF_KEYS, data);
  }
  getKeyDetails(data) {
    return this._httplayer.post(Config.API.CLOUD_DEVICE_KEY_DETAILS, data);
  }
  createNewKey(data) {
    return this._httplayer.post(Config.API.CLOUD_DEVICE_SAVE_KEY, data);
  }
  createGateWayForDevice(data) {
    return this._httplayer.post(Config.API.CLOUD_CREATE_GATEWAY_FOR_DEVICE, data);
  }
  deleteGateWayForDevice(data) {
    return this._httplayer.post(Config.API.CLOUD_DELETE_GATEWAY_FOR_DEVICE, data);
  }
  createNewCloudDevice(data) {
    return this._httplayer.post(Config.API.CLOUD_CREATE_NEW_DEVICE, data);
  }
  getCloudDeviceDetails(data) {
    return this._httplayer.post(Config.API.CLOUD_DEVICE_DETAILS, data);
  }
  getCloudDownlodableLinks(data) {
    return this._httplayer.post(Config.API.CLOUD_GET_DOWNLODABLE_LINKS, data);
  }
  updateCloudDeviceTagConfiguration(data) {
    return this._httplayer.post(Config.API.CLOUD_DEVICE_TAG_CONFIGURATION, data);
  }
  // ================================ OEE Configuration ==========================================
  viewConfiguredOeeData(data) {
    return this._httplayer.post(Config.API.VIEW_OEE_CONFIGURED_DATA, data);
  }
  saveOeeConfiguration(data) {
    return this._httplayer.post(Config.API.SAVE_OEE_CONFIGURATION_DATA, data);
  }
  // ============================== OEE Dashboard ===============================================
  getOEEMetaData(data) {
    return this._httplayer.post(Config.API.GET_OEE_META_DATA, data);
  }
  getOEEDevicesForSites(data) {
    return this._httplayer.post(Config.API.GET_OEE_DEVICES_FOR_SITES, data);
  }
  getOEEVisualizationData(data) {
    return this._httplayer.post(Config.API.GET_OEE_VISUALISATION_DATA, data);
  }

  // ============================================== Device Configuration ===========================================
  filterVirtualDevicesWithSites(data) {
    return this._httplayer.post(Config.API.FILTER_VIRTUAL_DEVICES_WITH_SITES, data);
  }
  // ================================================= SPC ========================================================
  getSPCMetaData(payload): Observable<any> {
    return this._httplayer.post(Config.API.GET_SPC_META_DATA, payload);
  }
  // =================================================== Pipeline Builder ===========================================
  createNewPipeline(data_to_send) {
    return this._httplayer.post(Config.API.CREATE_PIPELINE, data_to_send); // Need to update
  }
  deletePipeline(data_to_send) {
    return this._httplayer.post(Config.API.DELETE_PIPELINE, data_to_send); // Need to update
  }
  getTopicMetaData(data_to_send) {
    return this._httplayer.post(Config.API.LOAD_TOPICS_META_AFTER_BUILD, data_to_send); // Need to update
  }
  // /flow_diagram/get_pipeline_debug_topic_map

  getLibraryMetaData(data_to_send) {
    return this._httplayer.post(Config.API.LOAD_LIBRARY_META, data_to_send); // Need to update
  }
  savePipeline(data_to_send) {
    return this._httplayer.post(Config.API.SAVE_PIPELINE, data_to_send); // Need to update
  }
  buildPipeline(data_to_send) {
    return this._httplayer.post(Config.API.BUILD_PIPELINE, data_to_send); // Need to update
  }
  renamePipeline(data_to_send) {
    return this._httplayer.post(Config.API.RENAME_PIPELINE, data_to_send); // Need to update
  }
  runPipeline(data_to_send) {
    return this._httplayer.post(Config.API.RUN_PIPELINE, data_to_send); // Need to update
  }
  upgradePipeline(data_to_send) {
    return this._httplayer.post(Config.API.UPDATE_PIPELINE, data_to_send); // Need to update
  }
  // --------------------------------- Custom Nodes--------------------------------------
  customNodeCreate(custom_node_data) {
    return this._httplayer.post(Config.API.CREATE_CUSTOME_NODE, custom_node_data); // Need to update
  }
  customNodeFetch(node_fetch_create) {
    return this._httplayer.post(Config.API.FETCH_CUSTOM_NODE, node_fetch_create); // Need to update
  }
  customNodeDelete(node_delete) {
    return this._httplayer.post(Config.API.DELETE_CUSTOM_NODE, node_delete); // Need to update
  }
  getTemplete(get_templete) {
    return this._httplayer.post(Config.API.GET_CUSTOM_TEMPLTATE, get_templete); // Need to update
  }

  // =============================== Components and category's creation ===============================
  // --------------------------------------- categories -------------------------------------
  getPipelineCategoryList(get_list) {
    return this._httplayer.post(Config.API.GET_PIPELINE_CATEGORY_LIST, get_list);
  }
  pipelineCategoryRecord(record) {
    return this._httplayer.post(Config.API.GET_PIPELINE_CATEGORY_RECORD, record);

  }
  // --------------------------------------- components -------------------------------------
  getPipelineComponentsList(get_list) {
    return this._httplayer.post(Config.API.GET_PIPELINE_COMPONENTS_LIST, get_list);
  }
  makePipelineComponentPublic(input_data) {
    return this._httplayer.post(Config.API.MAKE_PIPELINE_COMPONENT_PUBLIC, input_data);
  }
  // -------------------------------- pipe Line Jobs -------------------------------------
  fetchJobsTable(data_to_send) {
    return this._httplayer.post(Config.API.PIPELINE_JOBS_LISTING, data_to_send);
  }
  saveNodeConfiguration(data_to_send) {
    return this._httplayer.post(Config.API.SAVE_NODE_CONFIGURATION, data_to_send);
  }

  // ----------------------------------------- Device Manager -------------------------------------------------------
  fetchDeviceGroupList(data_to_send) {
    return this._httplayer.post(Config.API.DEVICE_MANGER_GROUP_LIST, data_to_send);
  }
  createDeviceGroup(data_to_send) {
    return this._httplayer.post(Config.API.DEVICE_MANAGER_SAVE_DEVICE_GROUP, data_to_send);
  }
  addDeviceToDeviceGroup(data_to_send) {
    return this._httplayer.post(Config.API.DEVICE_MANAGER_SAVE_DEVICE, data_to_send);
  }
  fetchDEvicesForDeviceGroup(data_to_send) {
    return this._httplayer.post(Config.API.DEVICE_MANAGER_GET_DEVICE_LIST, data_to_send);
  }
  getDeviceDetailsOfDeviceManager(data_to_send) {
    return this._httplayer.post(Config.API.DEVICE_MANAGER_GET_DEVICE, data_to_send);
  }

  getModelsList(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.GET_MODELS_LIST, payload);
  }

  deployModelToDevices(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.DEPLOY_MODEL_TO_DEVICES, payload);
  }

  download_configurations(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.DOWNLOAD_CONFIGURATIONS, payload);
  }
  fetchDeviceTypesForDeviceConfig(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.FETCH_DEVICE_TYPES_FOR_DEVICE_CONFIG, payload);
  }
  fetchDevicePipelines(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.FETCH_DEVICE_PIPELINES, payload);
  }
  fetchDeviceAuditLogs(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.FETCH_DEVICE_AUDIT_LOGS, payload);
  }
  // =============================== Delete Annotation (168) ============================
  deleteAnnotation(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.DELETE_WIDGET_ANNOTATION, payload);
  }
  // ================================ changing Left Sidebar Order ==================
  updateLeftSidebarOrder(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.UPDATE_LEFT_SIDEBAR_ORDER, payload);
  }

  // -----------------------------------Profile Service--------------------------------------------------
  loadUserProfile(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.LOAD_USER_PROFILE, payload);
  }
  updateUserProfile(payload: any): Observable<any> {
    return this._httplayer.post(Config.API.UPDATE_USER_PROFILE, payload);
  }

  openInNewTab(url) {
    const currentUrl = window.location.href.split('/#/');
    // tslint:disable-next-line:prefer-template
    const routeUrl = currentUrl[0] + '/#/' + url;
    window.open(routeUrl, '_blank');
  }
  getCurrentUrl(route) {
    const mainUrl = window.location.href.split('/#/');
    // tslint:disable-next-line:prefer-template
    return mainUrl[0] + '/#/' + route;
  }
}
